import { render, staticRenderFns } from "./bofangChater.vue?vue&type=template&id=16458856&scoped=true"
import script from "./bofangChater.vue?vue&type=script&lang=js"
export * from "./bofangChater.vue?vue&type=script&lang=js"
import style0 from "./bofangChater.vue?vue&type=style&index=0&id=16458856&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16458856",
  null
  
)

export default component.exports